import { useRouter } from 'next/router';
import { ReservationPhase } from '../../lib/booking/reservation-phase';
import { states } from '../../lib/booking/reservation-states';
import { useLabels } from '../../lib/translations/useLabels';
import CtaButton from '../_Atoms/CtaButton';

const BOOK_AGAIN_PHASES: ReservationPhase[] = ['completed', 'cancelled', 'declined', 'expired'];

export function reservationPhaseLabelPath(phase: ReservationPhase) {
  return `reservationPhase.label.${phase}`;
}

function noticePath(phase: ReservationPhase, state: number) {
  if (phase === 'expired') {
    return state === states.WAITLIST
      ? 'reservationPhase.notice.expiredWaitlist'
      : 'reservationPhase.notice.expiredRequest';
  }
  return `reservationPhase.notice.${phase}`;
}

/**
 * Replaces the change/cancel actions once a reservation is locked, telling the guest why and,
 * when the visit is over, offering a way to book again.
 */
export default function ReservationPhaseNotice({
  phase,
  reservation,
}: {
  phase: ReservationPhase;
  reservation: Reservation;
}) {
  const router = useRouter();
  const { getLabel } = useLabels();

  if (phase === 'active') return null;

  return (
    <div
      data-testid="reservation-phase-notice"
      data-phase={phase}
      className="w-full max-w-[460px] mx-auto flex flex-col items-center gap-4 pt-4 pb-[2.375rem] text-center"
    >
      <p role="status" className="font-light">
        {getLabel(noticePath(phase, reservation.state))}
      </p>
      {BOOK_AGAIN_PHASES.includes(phase) && reservation.venueId && (
        <CtaButton
          dataTestId="book-again"
          icon="calendarBlank"
          onClick={() => router.push(`/venue/${reservation.venueId}/new-reservation/count`)}
        >
          <>{getLabel('reservationPhase.bookAgain')}</>
        </CtaButton>
      )}
    </div>
  );
}
